import { render, staticRenderFns } from "./SampleRequestMaker.vue?vue&type=template&id=f5a36fd2"
import script from "./SampleRequestMaker.vue?vue&type=script&lang=js"
export * from "./SampleRequestMaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports